<template>
    <div class='tbqd twoBox' v-if='tbdwmc'>
        <div class="redBox">
            <!-- <p class='red' v-if='!isBegin'>签到未开始</p> -->
            <!-- <div v-else> -->
            <div>
                <p>开标剩余时间</p>
                <myClock class='small lf' :shenyu='shenyu' :key='shenyu' cId='c1'></myClock>
            </div>
        </div>
        <div class="box">
            <table class='show'>
                <colgroup width='160px'></colgroup>
                <tr>
                    <td>投标单位</td>
                    <td>{{tbdwmc}}</td>
                </tr>
            </table>
        </div>
    </div>
    <div v-else class='loading'>
        <p>页面正在加载中...</p>
        <div id="colorfulPulse">
            <span class='item-1'></span>
            <span class='item-2'></span>
            <span class='item-3'></span>
            <span class='item-4'></span>
            <span class='item-5'></span>
            <span class='item-6'></span>
            <span class='item-7'></span>
        </div>
    </div>
</template>
<script>
import myClock from '../components/clock/clock'
export default {
    name:'tbqd',
    props:['djlcId'],
    components:{
        myClock
    },
    data(){
        return{
            isBegin:true,
            shenyu:0,
            tbdwmc:'',
            qdsj:'',
            sfqd:false,//是否已签到
            intervalTbqd:null,
            jgdm:'',
        }
    },
    methods:{
        getData(){
            let para={
                djlcId:this.djlcId
            }
            this.$api.kbqdTbr(para).then(res=>{
                if(res.data.meta.success){
                    this.isBegin=res.data.data.sfqd=='0'?false:true;//招标人是否开启签到
                    this.shenyu=res.data.data.djs;
                    if(res.data.data.tbdw){
                        this.tbdwmc=res.data.data.tbdw.fcqymc;
                        this.jgdm=res.data.data.tbdw.fcqyjgdm;
                        this.sfqd=res.data.data.tbdw.sfqd=='0'?false:true;//投标人是否已签到
                        if(this.shenyu>=1000){
                            if(this.sfqd){
                                this.qdsj=this.$moment(res.data.data.tbdw.qdsj).format("YYYY-MM-DD HH:mm:ss");
                            }else{
                                this.qdsj='';
                                this.tbqdshenyuFun();
                            }
                        }else{
                            //签到倒计时结束
                            if(this.sfqd){
                                this.qdsj=this.$moment(res.data.data.tbdw.qdsj).format("YYYY-MM-DD HH:mm:ss");
                            }else{
                                this.qdsj='<span class="red">未签到</span>'
                            }
                        }
                    }else{
                        this.tbdwmc=localStorage.getItem('user');
                        if(this.shenyu>=1000){
                            this.qdsj='';
                            this.tbqdshenyuFun();
                        }else{
                            //签到倒计时结束
                            this.qdsj='<span class="red">未签到</span>';
                            let obj={
                                lx:'tb',
                                data:{
                                    index:0,
                                    msg:'3',
                                    all:false
                                }
                            }
                            this.$emit('send',JSON.stringify(obj))
                            }
                    }
                    
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
            }).catch(()=>{})
        },
        //计算剩余时间倒计时
        tbqdshenyuFun(){
            var _this=this;
            var time=_this.shenyu
            clearInterval(_this.intervalTbqd);
            _this.intervalTbqd=null;
            _this.intervalTbqd=setInterval(function(){
                if(time<1000){
                    clearInterval(_this.intervalTbqd);
                     _this.intervalTbqd=null;
                    if(!_this.sfqd){
                        _this.qdsj='<span class="red">未签到</span>';
                        let obj={
                            lx:'tb',
                            data:{
                                index:0,
                                msg:'3',
                                all:false
                            }
                        }
                        _this.$emit('send',JSON.stringify(obj))
                    }
                    clearInterval(_this.intervalTbqd);
                     _this.intervalTbqd=null;
                    return;
                }
                time=time-2000;
            },2000)
        }, 
    },
    mounted(){
        this.getData();
    },
    beforeDestroy(){
        clearInterval(this.intervalTbqd);
        this.intervalTbqd=null;
    }
}
</script>
<style lang="less" scoped>
   
</style>